<div style="padding: 1rem">
  <h2 matDialogTitle>Metoda niedostępna</h2>

  <p>Dodaj opłaty do koszyka, żeby umożliwić wybranie metody płatności.</p>

  <mat-dialog-actions align="start">
    <button color="accent" mat-raised-button matDialogClose>Zamknij</button>
  </mat-dialog-actions>

</div>
